<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="none">
      <path
        fill="none"
        stroke="inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m13 17.5 5-5m0 0-5-5m5 5H6"
      />
    </svg>
  </span>
</template>
